module.exports = __webpack_public_path__ + "static/media/Logo-light.ac1a0069.svg";